<script setup>
import emptyFolderImg from "~/images/empty-folder.png";

defineProps({
  description: { default: null, type: String },
  title: { required: true, type: String }
});
</script>

<template>
  <div class="flex flex-col items-center py-16 text-center">
    <img :src="emptyFolderImg" class="mb-4 w-32 opacity-60" alt="" />
    <h2 class="text-lg font-semibold text-[var(--gl-text-color-default)]">{{ title }}</h2>
    <p v-if="description" class="mt-1 text-sm text-[var(--gl-text-color-subtle)]">{{ description }}</p>
  </div>
</template>
